import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, Subscription } from 'rxjs';
import { AssetsService } from 'src/app/services/assets.service';

@Component({
  selector: 'app-asset',
  standalone: false,
  templateUrl: './asset.component.html',
  styleUrl: './asset.component.scss'
})
export class AssetComponent implements OnChanges, OnDestroy {

  @Input('assetSrc') assetSrc: string | undefined;
  @Input('assetId') assetId: number | undefined;

  private readonly SAFFRON_STAR = "./../../../assets/icons/star-saffron.svg";
  private getAssetSubscription: Subscription = new Subscription();

  public src: string = "";
  public get isBulgariStar(): boolean {
    return this.src === this.SAFFRON_STAR;
  }

  constructor(
    private readonly assetService: AssetsService,
  ) { }

  ngOnChanges(): void {
    this.src = this.SAFFRON_STAR;
    if (!this.getAssetSubscription.closed) {
      this.getAssetSubscription.unsubscribe()
    }
    if (this.assetSrc) {
      this.src = this.assetSrc;
    }
    if (this.assetId) {
      this.getAssetSubscription = this.assetService.getAsset(this.assetId).subscribe(
        (asset) => {
          this.src = asset || "";
        })
    }
  }

  ngOnDestroy(): void {
    this.getAssetSubscription.unsubscribe();
  }

  handleOnError() {
    this.src = this.SAFFRON_STAR;
  }

}
